export type { PipelineMetadata } from './PipelineMetadata';
export type { PipelineDefinition } from './PipelineDefinition';
export { PipelineRegistry, getPipelineRegistry, edgeStreamRegistry } from './PipelineRegistry';
export {
  DefaultIncomingPipeline,
  SecurityIncomingPipeline,
  DefaultOutgoingPipeline,
  MinimalOutgoingPipeline,
  STANDARD_PIPELINES,
} from './StandardPipelines';
export { RegistryManager } from './RegistryManager';
export type { RegistryEntry } from './RegistryManager';

// Initialize the default registry with standard pipelines loader
import { STANDARD_PIPELINES } from './StandardPipelines';
import { edgeStreamRegistry } from './PipelineRegistry';

edgeStreamRegistry.setStandardPipelinesLoader(() => STANDARD_PIPELINES);
